import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { HttpErrorResponse } from '@angular/common/http'
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
@Component({
  selector: 'app-student-register',
  templateUrl: './student-register.component.html',
  styleUrls: ['./student-register.component.scss']
})
export class StudentRegisterComponent implements OnInit {
  public showPassword: boolean;
  public showPassword2: boolean;
  timerInterval: NodeJS.Timeout;
  
  constructor(public router: Router,private fb: FormBuilder,
    private spinner :NgxSpinnerService,
    private modalPopupService: ModalpopService,public umsService:UmsService) { }
  registrationForm: FormGroup;
  dialogRef: MatDialogRef<any>;
  sessionList: any;
  hide = true;
  emaildisabled = false;
  emailverified = false;
  mobileVerified = false;
  otpverify= false;
  showerr = false;
  Message = false
  msgshw = false
  msgshw2 =false;
  ErrorMsg = ''
  messageee = ''
  regibtm = true;
  btnShow = false
btnShow2 = true;
emailInterval :any
isEmailOtpSent: boolean = false;
otpEmailTimer: number = 60;
  emailTimer: any;
  startEmailTimer: boolean = false;
  sendotpmail = false;
  bfrsendotpmail = true
  sendotpmail1: boolean = true;
  isDivDisabled: boolean = false;
  remainingTime: number = 60;
  resendotp = false;
  send1stotp = true;
  isEmailValid: boolean = false;
  isEmailDisabled: boolean = false;

  ngOnInit(): void {
    this.Message = false
    this.ErrorMsg = ''
    this.registrationForm = this.fb.group({
      StuFirstName: new FormControl('',[Validators.required, Validators.pattern('^[a-zA-z-]*$')]),
      StuMidName: new FormControl('',[Validators.required, Validators.pattern('^[a-zA-z-]*$')]),
      StuLastName: new FormControl('',[Validators.required, Validators.pattern('^[a-zA-z-]*$')]),
    //  StuFullName: new FormControl('',[Validators.required, Validators.pattern('^[a-zA-z-]*$')]),
      // (?![0-9]+@)([A-Za-z0-9._%-]+)@([A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*)\.[A-Za-z]{2,3}
      StuEmailId: new FormControl('',[Validators.required,Validators.pattern('(?![0-9]+@)([A-Za-z0-9._%-]+)@([A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*)\.[A-Za-z]{2,3}')]),
      StuMobNumber: new FormControl('',[Validators.required,Validators.pattern('(0|91)?[6-9][0-9]{9}')]),
      StuCountryCode: new FormControl(''),
      StuPassword: new FormControl('',Validators.required),
      StuRegStatus: new FormControl(1),
      emailOTP:new FormControl(''),
      StuPassword1: new FormControl('',Validators.required)

    });
    
  }
 

  togglePasswordVisibility() {
    this.hide = !this.hide;
  }

registerStudent(){
  this.Message = false
  this.ErrorMsg = ''
  if(this.emailverified){
    this.Message = false
    this.ErrorMsg = ''
    this.spinner.show();
    let payload = this.registrationForm.value;
    payload['StuFullName'] = '';
    payload['StuabcID'] = '';
    payload['StudebID'] = '';
    console.log("payload: ", payload);
    //return
     this.umsService.studRegistrationDetails(payload).subscribe(res => {
      // this.spinner.hide();
      console.log(res);
      if (res.status == true) {
        this.spinner.hide();
        this.Message = false
        this.ErrorMsg = ''
        alert('Registered Successfully')
      this.redirect('student-login');
      this.umsService.openSnackbar(res.message);
    }else{
      this.spinner.hide();
      this.Message = true
      this.ErrorMsg = res.message
    }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.Message = true
      this.ErrorMsg =  ERROR.error.message
      // let data = {}
      //   data['message'] = ERROR.error.message
      //   data['title'] = 'Information'
      //   data['icon'] = 'fas fa-check'
      //   this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      //  this.showerr = true;
      // this.umsService.openSnackbar(ERROR.error.message);
      // alert(ERROR.error.message)
   });
  }else{
    this.Message = true
    this.ErrorMsg =  'Please Verify OTP'
    // this.showerr = true;
    // this.umsService.openSnackbar("Please Verify EmailId");
  }

  }

  // sendEmailWithTimeout() {
  //   // Disable the div
  //   this.isDivDisabled = true;

  //   // Enable the div after 60 seconds
  //   setTimeout(() => {
  //     this.isDivDisabled = false;
  //   }, 60000); // 60 seconds in milliseconds

  //   // Your other logic for sending the email goes here
  //   this.SendEmail();
  // }

  sendEmailWithTimeout() {
    // if (this.registrationForm.controls['StuEmailId'].invalid || this.isDivDisabled) {
    //   return; // Exit the function if the email is invalid or the button is disabled
    // }
    // if (!this.registrationForm.controls['StuEmailId'].valid ) {
    //   return; // Exit the function if the email is invalid
    // }
    const emailControl = this.registrationForm.controls['StuEmailId'];
    if (emailControl.invalid || this.isDivDisabled) {
      return; // Exit the function if the email is invalid or the button is disabled
    }
    // Disable the div
    this.isDivDisabled = true;
    this.resendotp = false;
    this.send1stotp = true;
    // Start the countdown
    // const timerInterval = setInterval(() => {
    //   this.remainingTime--;

    //   if (this.remainingTime <= 0) {
    //     // Enable the div when the timer reaches 0
    //     this.isDivDisabled = false;
    //     clearInterval(timerInterval);
    //   }
    // }, 1000); // Update the timer every second

    this.timerInterval = setInterval(() => {
      this.remainingTime--;
      this.isEmailDisabled = true;
      if (this.remainingTime === 0) {
        clearInterval(this.timerInterval);
        this.isDivDisabled = false;
        this.remainingTime = 60; // Reset the timer for the next attempt
        this.resendotp = true;
        this.send1stotp = false;
        this.isEmailDisabled = false;
      }
    }, 1000);

    // Your other logic for sending the email goes here
    this.SendEmail();
  }

  resendEmailWithTimeout() {
    // Disable the div
    this.isDivDisabled = true;
    this.resendotp = true;
    this.send1stotp = false;
    this.msgshw = false;
      this.msgshw2 = false;
    this.registrationForm.controls['emailOTP'].setValue('');
    this.registrationForm.controls['emailOTP'].clearValidators();
    this.timerInterval = setInterval(() => {
      this.remainingTime--;
       this.isEmailDisabled = true;
      if (this.remainingTime === 0) {
        clearInterval(this.timerInterval);
        this.isDivDisabled = false;
        this.remainingTime = 60; // Reset the timer for the next attempt
        this.resendotp = true;
        this.send1stotp = false;
        this.isEmailDisabled = false;
      }
    }, 1000);

    // Your other logic for sending the email goes here
    this.SendEmail();
  }
  SendEmail(){
      this.emaildisabled = true;
      this.otpverify = false;
      this.spinner.show();
      let payload = {};
      payload['StuEmailId'] = this.registrationForm.value.StuEmailId;
      this.umsService.SendEmail(payload).subscribe(res => {
        if(res.status){
          this.sendotpmail = true;
          this.bfrsendotpmail = false
          this.spinner.hide();
          sessionStorage.setItem("emailotp",res.EmailOtpV);
          this.otpverify = true;
        this.umsService.openSnackbar("Email Sent to - "+this.registrationForm.value.StuEmailId);
        }else{
          this.sendotpmail = false;
          this.bfrsendotpmail = true
        }
       
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.umsService.openSnackbar(ERROR.error.message);
     });
    // }
   
  }

  verifyEmailOtp(){
    let sentotp = sessionStorage.getItem("emailotp");
    let enterotp = this.registrationForm.value.emailOTP;
    if(sentotp == enterotp){
      // alert("OTP Verified");
    //this.umsService.openSnackbar("OTP Verified");
      this.emaildisabled = true;
      this.emailverified = true;
      this.otpverify = false;
      this.msgshw = true;
      this.msgshw2 = false;
      this.regibtm = false;
      this.btnShow = true;
      this.btnShow2 = false;
      this.messageee = "OTP Verified"
    }else{
    //this.umsService.openSnackbar("Invalid Otp");
    // alert("Invalid Otp");
      this.emaildisabled = false;
      this.otpverify = true;
      this.msgshw = false;
      this.msgshw2 = true;
      this.regibtm = true;
      this.btnShow = false;
      this.btnShow2 = true;
      this.messageee = "Invalid OTP"
    }
  }
  SendOtp(){
    this.umsService.openSnackbar("otpotpmobileotp")
  }
  verifymobileOtp(){
    this.mobileVerified = true;
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  SignIn(){
      this.redirect('student-login');
    }

    register(){
   
      console.log(this.registrationForm);
      if(this.registrationForm.invalid){
        this.Message =false
        // this.showerr = true;
        this.registrationForm.get('StuFirstName').markAsTouched();
         this.registrationForm.get('StuMidName').markAsTouched();
         this.registrationForm.get('StuLastName').markAsTouched();
         this.registrationForm.get('StuEmailId').markAsTouched();
         this.registrationForm.get('StuMobNumber').markAsTouched();
         this.registrationForm.get('StuPassword').markAsTouched();
         this.registrationForm.get('emailOTP').markAsTouched();
         this.registrationForm.get('StuPassword1').markAsTouched();
         if(this.registrationForm.value['StuPassword'] != this.registrationForm.value['StuPassword1']){
          this.Message = true
          this.ErrorMsg = 'Password and Confirm Password should be same'
        }
        else if(this.registrationForm.value['StuPassword'] == this.registrationForm.value['StuPassword1']){
          this.Message = false
          this.ErrorMsg = ''
        }
      }
      else{
        if(this.registrationForm.value['StuPassword'] != this.registrationForm.value['StuPassword1']){
          this.Message = true
          this.ErrorMsg = 'Password and Confirm Password should be same'
        }
        else if(this.registrationForm.value['StuPassword'] == this.registrationForm.value['StuPassword1']){
          this.Message = false
          this.ErrorMsg = ''
          this.registerStudent();
        }
        
      }
    }


    isValidEmail(email: string): boolean {
      // const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const emailRegex: RegExp = /^(?![0-9]+@)([A-Za-z0-9._%-]+)@([A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*)\.[A-Za-z]{2,3}$/i;
      return emailRegex.test(email);
  }
  
  emailvali(value: string) {
      this.isEmailValid = this.isValidEmail(value);
  }
}